import React from 'react'

export default function SkipStep(props) {
  return (
    <div className="form-group custom textarea">
      <textarea
        rows="3"
        data-gramm_editor="false"
                      spellCheck="false"
        className="form-control"
        placeholder="&nbsp;"
        onChange={props.skipStepMessageHandler}
        value={props.action_value?.message}
      />
      <label>Message</label>
    </div>
  )
}
